import { render, staticRenderFns } from "./RegStore.vue?vue&type=template&id=1a47141a&scoped=true"
import script from "./RegStore.vue?vue&type=script&lang=js"
export * from "./RegStore.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RegStore.vue?vue&type=style&index=1&id=1a47141a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47141a",
  null
  
)

export default component.exports